
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "AnemiaClassification",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/AnemiaClassification.vue